// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a8bdadaa","703":"d3b48126"}[chunkId] + ".chunk.js";
};